import { RiHistoryLine, RiArrowRightSLine, RiTeamLine, RiBuildingLine } from '@remixicon/react';
import { Card, CardHeader, CardContent } from '@components/ui/Card';
import { getFinancialStatusConfig } from '../utils';
  
const RecentReports = ({ reports = [] }) => {
  if (reports.length === 0) return null;

  return (
    <Card className="overflow-hidden !rounded-3xl !border !border-gray-100 !shadow-none">

      <CardHeader className="!border-gray-100">
        {/* Header */}
        <div className="flex items-center gap-2">
          <RiHistoryLine className="w-5 h-5 text-gray-500" />
          <span className="font-medium text-gray-900">Recent Reports</span>
          <RiArrowRightSLine className="w-5 h-5 text-gray-500 ml-auto" />
        </div>
      </CardHeader>

      <CardContent className="p-4">
        {/* List */}
        <div className="space-y-0">
          {reports.map((report, index) => (
            <div key={index} className="py-3 first:pt-0">
              <div className="flex items-start justify-between">
                <div className="text-gray-500">Trip <span className="font-medium !text-gray-700">{report.tripNumber}</span></div>
                <div className="flex items-center gap-2">
                  <span className={`text-xs px-2 py-0.5 rounded-md ${getFinancialStatusConfig(report.status).className}`}>
                    {getFinancialStatusConfig(report.status).label}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-1 text-sm text-gray-500 mt-1">
                <RiTeamLine className="w-3.5 h-3.5" />
                <span>{report.clientName}</span>
              </div>
              <div className="flex items-center justify-between mt-0.5">
                <div className="flex items-center gap-1 text-sm text-gray-500">
                  <RiBuildingLine className="w-3.5 h-3.5" />
                  <span>{report.operatorInfo}</span>
                </div>
                <RiArrowRightSLine className="w-4 h-4 text-gray-500" />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default RecentReports;
